import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = { class: "p-mx-2" }
const _hoisted_6 = { class: "st-style p-text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Total", -1)
const _hoisted_9 = { style: {"word-break":"break-all","overflow-wrap":"anywhere"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}, " Stock Loss (Free Qty) ", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}, " Stock Found (Zero Cost) ", -1)
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}, " Stock Loss ", -1)
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}, " Inventory Value Change ", -1)
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}
const _hoisted_24 = { key: 6 }
const _hoisted_25 = {
  key: 0,
  class: "text-muted",
  style: {"font-size":"0.85em","display":"block"}
}
const _hoisted_26 = { key: 7 }
const _hoisted_27 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h4", null, "Please choose any of the action below :", -1)
const _hoisted_29 = { class: "p-grid" }
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, " Receipt Payments ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1)
const _hoisted_33 = {
  key: 0,
  class: "p-mt-3 p-p-3",
  style: {"background":"#fff3cd","border":"1px solid #ffc107","border-radius":"4px"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("strong", null, " Internal inventory adjustment - no financial transaction recorded.", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h6", { class: "p-dialog-titlebar p-dialog-titlebar-icon" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-money-bill",
    style: {"color":"orangered"}
  }),
  /*#__PURE__*/_createTextVNode(" Confirm Receipt of Payment ")
], -1)
const _hoisted_39 = { style: {"padding":"32px","max-width":"700px","margin":"0 auto"} }
const _hoisted_40 = { style: {"text-align":"center","margin-bottom":"24px"} }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { style: {"color":"#6c757d","font-size":"0.85em","text-transform":"uppercase","letter-spacing":"0.08em","margin-bottom":"4px"} }, " Total Amount to Receive ", -1)
const _hoisted_42 = { style: {"font-size":"3.5rem","font-weight":"bold","color":"#c00","line-height":"1"} }
const _hoisted_43 = {
  key: 0,
  style: {"margin-top":"10px","color":"#555","font-size":"0.95em"}
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-building",
  style: {"margin-right":"6px"}
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Paid by: ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("hr", { style: {"border-color":"#dee2e6","margin-bottom":"24px"} }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h6", { style: {"margin-bottom":"12px","color":"#333"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-list",
    style: {"color":"orangered","margin-right":"6px"}
  }),
  /*#__PURE__*/_createTextVNode(" Payment Breakdown ")
], -1)
const _hoisted_48 = {
  class: "table table-bordered table-striped",
  style: {"width":"100%"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"background":"#11467e","color":"#fff"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"padding":"12px","width":"50px"} }, "#"),
    /*#__PURE__*/_createElementVNode("th", { style: {"padding":"12px"} }, "Payment Method"),
    /*#__PURE__*/_createElementVNode("th", { style: {"padding":"12px","text-align":"right"} }, "Amount")
  ])
], -1)
const _hoisted_50 = { style: {"padding":"12px"} }
const _hoisted_51 = { style: {"padding":"12px"} }
const _hoisted_52 = { style: {"padding":"12px","text-align":"right","font-weight":"500"} }
const _hoisted_53 = { style: {"background":"#e9ecef","font-weight":"bold"} }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"padding":"12px"}
}, "Total", -1)
const _hoisted_55 = { style: {"padding":"12px","text-align":"right"} }
const _hoisted_56 = { style: {"display":"flex","gap":"12px","margin-top":"28px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SearchFilter = _resolveComponent("SearchFilter")!
  const _component_PosPreviewReceipt = _resolveComponent("PosPreviewReceipt")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.itemFilter.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemFilter.type) = $event)),
              options: _ctx.receiptTypes,
              optionLabel: "key",
              optionValue: "value",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              modelValue: _ctx.itemFilter.keyword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemFilter.keyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Receipt No/ Bill No"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search ",
              class: "p-button-primary p-mr-1",
              onClick: _ctx.loadSearchData
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-calendar",
              class: "p-button-warning",
              onClick: _ctx.openFilterDialog
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              icon: "pi pi-times ",
              class: "p-button-info p-mr-1",
              onClick: _ctx.cleanSearchData
            }, null, 8, ["onClick"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("b", null, _toDisplayString(_ctx.statement), 1)
      ]),
      _createVNode(_component_DataTable, {
        first: _ctx.goToFirstLink,
        "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
        firstModifiers: { sync: true },
        value: _ctx.lists,
        lazy: true,
        paginator: _ctx.checkPagination,
        rows: _ctx.limit,
        totalRecords: _ctx.totalRecords,
        scrollable: true,
        onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
      }, {
        empty: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { header: "Receipt Date" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.receipt_date)), 1)
            ]),
            footer: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "receipt_no",
            header: "Receipt No"
          }),
          (_ctx.itemFilter.type == 'PUR' || _ctx.itemFilter.type == 'RPU')
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "bill_no",
                header: "Bill No",
                style: { minWidth: '120px', maxWidth: '160px' }
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(slotProps.data.bill_no), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, { header: "Account Title" }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.type === 'TSO')
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.data.tso_counterpart_branch), 1))
                : (slotProps.data.type === 'TSI')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(slotProps.data.tsi_counterpart_branch), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(slotProps.data.temp_customer_name
                                    ? slotProps.data.temp_customer_name
                                    : slotProps.data.profile_name.profileName), 1))
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Total Amount" }, {
            body: _withCtx((slotProps) => [
              (_ctx.isFreeLoss(slotProps.data))
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.currency) + " 0.00 ", 1)
                  ]))
                : (_ctx.isStockFound(slotProps.data))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.currency) + " 0.00 ", 1)
                    ]))
                  : (slotProps.data.type === 'SAD' && slotProps.data.payment_method === 'None')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_gross_amt).toFixed(2)), 1)
                      ]))
                    : (slotProps.data.type === 'SAA' && slotProps.data.payment_method === 'None')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_gross_amt).toFixed(2)), 1)
                        ]))
                      : ((slotProps.data.type === 'SAA' || slotProps.data.type === 'SAD') && Number(slotProps.data.total_gross_amt) > Number(slotProps.data.total_bill))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_gross_amt).toFixed(2)), 1))
                        : (slotProps.data.type === 'TSO')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              (Number(slotProps.data.total_gross_amt) === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Free Qty Transfer "))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_gross_amt).toFixed(2)), 1)
                            ]))
                          : (slotProps.data.type === 'TSI')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                (Number(slotProps.data.total_gross_amt) === 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Free Qty Received "))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_gross_amt).toFixed(2)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.total_bill).toFixed(2)), 1))
            ]),
            footer: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.totalAmountAllRecords).toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Balance" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                _ctx.calculateBalance(
                                    slotProps.data.total_bill,
                                    slotProps.data.receipt_balance,
                                    slotProps.data
                                )
                            )), 1)
            ]),
            footer: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.totalBalanceAllRecords).toFixed(2)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "description",
            header: "Description"
          }),
          _createVNode(_component_Column, { header: "Created By" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(slotProps.data.created_by_user || '-'), 1),
                (slotProps.data.updated_by_user && slotProps.data.updated_by_user !== slotProps.data.created_by_user)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, " Updated: " + _toDisplayString(slotProps.data.updated_by_user), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Store Name" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.branch.branchName) + " ( " + _toDisplayString(slotProps.data.branch.branchCode) + " ) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "Action"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Button, {
                icon: "pi pi-cog",
                class: "p-button-primary",
                onClick: ($event: any) => (_ctx.openMenu(slotProps.data))
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["first", "value", "paginator", "rows", "totalRecords"]),
      _createVNode(_component_Sidebar, {
        visible: _ctx.menuBar,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.menuBar) = $event)),
        position: "bottom",
        class: "p-sidebar-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (
                                !(
                                    _ctx.itemFilter.type == 'SAD' ||
                                    _ctx.itemFilter.type == 'SAA' ||
                                    _ctx.itemFilter.type == 'PUR' ||
                                    _ctx.itemFilter.type == 'RPU' ||
                                    _ctx.itemFilter.type == 'RFD' ||
                                    _ctx.itemFilter.type == 'TSO' ||
                                    _ctx.itemFilter.type == 'TSI'
                                )
                            )
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-print",
                    label: "PRINT POS RECEIPT",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              (_ctx.itemFilter.type == 'RFD')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "pi pi-print",
                    label: "PRINT REFUND RECEIPT",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              (_ctx.itemFilter.type == 'PUR')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    icon: "pi pi-print",
                    label: "PRINT PURCHASE RECEIPT",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              (_ctx.itemFilter.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    icon: "pi pi-print",
                    label: "PRINT RETURN RECEIPT",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printReceipt())),
                    class: "p-button-primary p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                icon: "pi pi-print",
                label: "VIEW RECEIPT",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.previewDialog())),
                class: "p-button-primary p-button-md p-mx-2"
              }),
              (
                                _ctx.itemFilter.type != 'ASR' &&
                                _ctx.totalBalanceReceipt > 0.02
                            )
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 4,
                    icon: "pi pi-money-bill",
                    label: "PAY/RECEIVE PAYMENT",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openPaymentScreen())),
                    class: "p-button-success p-button-md p-mx-2"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                icon: "pi pi-chart-bar",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openTransactionDialog())),
                label: "PAYMENT HISTORY",
                class: "p-button-warning p-button-md p-mx-2"
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.previewTransactionDialog,
        "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.previewTransactionDialog) = $event)),
        style: { width: '100vw' },
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized"
      }, {
        header: _withCtx(() => [
          _hoisted_31
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.selectedReceiptData.paymentTransactions,
            scrollable: true,
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_32
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Transaction Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.createdAt)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "sourceType",
                header: "Type"
              }),
              _createVNode(_component_Column, { header: "Receipt No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.receiptNo), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "paymentType",
                header: "Payment Type"
              }),
              _createVNode(_component_Column, { header: "Paid Amount" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(slotProps.data.transTotalAmount).toFixed(
                                    2
                                )), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "accountNo",
                header: "Reference"
              }),
              _createVNode(_component_Column, {
                field: "description",
                header: "Description"
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (_ctx.selectedReceiptData.paymentTransactions.length === 0 && (_ctx.item.type === 'SAA' || _ctx.item.type === 'SAD'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_37))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_Dialog, {
        visible: _ctx.tsoConfirmDialog,
        "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tsoConfirmDialog) = $event)),
        style: { width: '100vw' },
        modal: true,
        closable: true,
        position: "top",
        class: "p-fluid p-m-0 p-dialog-maximized",
        showHeader: true
      }, {
        header: _withCtx(() => [
          _hoisted_38
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(_ctx.tsoPreloadedPayments.reduce((s, p) => s + Number(p.amount), 0)).toFixed(2)), 1),
              (_ctx.tsoReceivingBranch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.tsoReceivingBranch), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_46,
            _hoisted_47,
            _createElementVNode("table", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tsoPreloadedPayments, (p, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: p.paymentType
                  }, [
                    _createElementVNode("td", _hoisted_50, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", _hoisted_51, [
                      _createElementVNode("i", {
                        class: _normalizeClass(p.paymentType === 'Cash' ? 'pi pi-money-bill' : 'pi pi-credit-card'),
                        style: {"margin-right":"6px","color":"#555"}
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(p.paymentType), 1)
                    ]),
                    _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(p.amount).toFixed(2)), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(_ctx.tsoPreloadedPayments.reduce((s, p) => s + Number(p.amount), 0)).toFixed(2)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_Button, {
                label: "Cancel",
                icon: "pi pi-times",
                class: "p-button-secondary p-button-lg",
                style: {"flex":"1","height":"60px"},
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.tsoConfirmDialog = false))
              }),
              _createVNode(_component_Button, {
                label: "Confirm Receipt",
                icon: "pi pi-check-circle",
                class: "p-button-success p-button-lg",
                style: {"flex":"2","height":"60px"},
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.confirmTsoReceipt()))
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_SearchFilter, {
        searchDetail: {
                    status: this.filterDialog,
                    dialogTitle: this.dialogTitle,
                    scenario: this.scenario,
                    selectedDateFilter: this.selectedDateFilter,
                    supplierFilter: this.supplierFilter,
                    selectedSupplierID: this.itemFilter.supplierID,
                },
        onUpdateFilterStatus: _ctx.updateFilterStatus
      }, null, 8, ["searchDetail", "onUpdateFilterStatus"]),
      _createVNode(_component_PosPreviewReceipt, {
        PreviewReceipt: {
                    status: this.previewPosReceipt,
                    dialogTitle: this.dialogTitle,
                    previewHeading: this.previewHeading,
                    receiptID: this.receiptID,
                },
        onUpdatePreviewStatus: _ctx.updatePreviewStatus
      }, null, 8, ["PreviewReceipt", "onUpdatePreviewStatus"]),
      _createVNode(_component_PaymentScreen, {
        receiptDetail: {
                    dialogStatus: _ctx.paymentDialog,
                    itemSource: _ctx.item.type,
                    restriction: 'No',
                    paymentOptionType: 'Transaction', //his is for enable/disble payment option buttons
                    cashPayment: this.cashPaymentOption,
                    cardPayment: this.cardPaymentOption,
                    bankTransferPayment: this.bankTransferPaymentOption,
                    chequePayment: _ctx.chequePaymentOption,
                    payLater: this.payLaterOption,
                    dialogTitle: _ctx.dialogTitle,
                    customerID: this.item.profileID,
                    customerName: this.item.selectedProfile,
                    closeConfirmation: true,
                    latency: this.latency,
                    paySupplierCredit: _ctx.paySupplierCredit,
                    supplierCreditAmount: _ctx.supplierCreditAmount,
                    payBranchCredit: _ctx.payBranchCredit,
                    branchCreditAmount: _ctx.branchCreditAmount,
                },
        onClosePaymentScreenEvent: _ctx.closePaymentScreen,
        onGetProceededPaymentsEvent: _ctx.getProceededPayments
      }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"])
    ])
  ]))
}